import React from "react"
import {NewsLayout} from "sections/News/"
import useNewsData from "shared/Hooks/News/useNewsData"
import {TextBlock} from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_34} from "types/News"

const Article = () => {
    const data = useNewsData(NEWS_34);

    return (
        <NewsLayout data={data}>
            <TextBlock data={data.texts.first}/>
            <TextBlock data={data.texts.second}/>
            <TextBlock data={data.texts.third}/>
            <TextBlock data={data.texts.fourth}/>
            <TextBlock data={data.texts.fifth}/>
        </NewsLayout>
    )
}

export default Article;
